
import * as React from 'react';

import { TooltipProps } from './TooltipTypes';
import { useResizeDetector } from 'react-resize-detector';

import { TooltipContainer, Tooltip } from './TooltipStyles';
import { Size } from '..';
 
interface TooltipOverflowProps extends TooltipProps {
    input?: React.MutableRefObject<HTMLInputElement | null>;
    maxWidth?: string;
    width?: string;
    value?: string;
}

 const TooltipOverflow = ({
   label, children,
   input,
   withArrow,
   maxWidth,
   width,
   value,
   size = Size.Small,
   height = 'auto',
   align = 'center', 
   position = 'top',
   ...props } : TooltipOverflowProps) => {

  const [textOverflowed, setTextOverflowed] = React.useState<boolean>(false);
  const [focused, setFocused] = React.useState<boolean>(false);
  const {width: customW, height: customH} = useResizeDetector({ targetRef: input });

  React.useEffect(() => {
    checkIfOverflowed();
  }, [customW, customH]);

  const checkIfOverflowed = () => {
    //adding +3 offset to offsetWidth, because sometimes when there is no overflow, scrollWidth can be equal to offsetWidth + 1
    const over = (input && !focused && input.current && input.current.offsetWidth + 3 < input.current.scrollWidth) ?? false;
    setTextOverflowed(over);
  };

  React.useEffect(() => {
    checkIfOverflowed();
  });

  const onFocus = () => {
    checkIfOverflowed();
    setFocused(true);
  };

  const onBlur = () => {
    setFocused(false);
  };

  React.useEffect(() => {
    return () => {
      if(input?.current)
      {
        input?.current.removeEventListener("focus", onFocus);
        input?.current.removeEventListener("blur", onBlur);
      }
    }
  }, []);

  const renderedCallback = React.useCallback(() => {
    if(input && input.current)
    {
      input.current.addEventListener("focus", onFocus);
      input.current.addEventListener("blur", onBlur);
      checkIfOverflowed();
    }
  }, []);
 
    return <div ref={renderedCallback}>{textOverflowed && <Tooltip align={align}
               height={height}
               role="tooltip"
               maxWidth={maxWidth}
               width={width}
               size={size}
               withArrow={withArrow}
               position={position}
               {...props}>
                <span>
               {children} </span>
            </Tooltip> }</div>;
 };
 
 export default TooltipOverflow;
